export const ERROR_CUSTOMER_NOT_FOUND = 'customer_not_found';
export const ERROR_PASSWORD_RESET_NOT_FOUND = 'password_reset_not_found';
